<mat-card appearance="outlined" class="blue-border-top dashboard-card"
  [ngClass]="{'gray-bg':(!module?.canAccess && module?.isDisabled || clientAccess === 'disabled')}"
  *ngIf="(!isWaiverManagementModule && clientAccess !== 'hide' && ( module?.canAccess || (module?.permission === 'WaiverManagement'))) && module?.blocks?.length > 0">
  <h2 class="uhc-h4"
    *ngIf="!isWaiverManagementModule && clientAccess !== 'hide' && ( module?.canAccess || (module?.permission === 'WaiverManagement'))">
    {{module?.blockName | titlecase}}</h2>
  <ng-container *ngFor="let block of module.blocks; let i = index">
    <div class="dasboard-card-block" *ngIf="block.blockName !== 'Approve Coverage'">
      <a fxLayoutGap="30px">
        <span fxFlex="10" class="block-image">
          <img src="{{block.image}}" [ngClass]="{'img-disabled':clientAccess === 'disabled'}"
            alt="{{block.blockName}} image" />
        </span>
        <span fxFlex>
          <span class="block-heading">
            <a *ngIf="clientAccess !== 'disabled' && selectedClient" href="javascript:void(0)"
              title="{{block.isAccessRestricted ? 'Access Restricted' : block.description}}"
              routerLink="/{{block?.url}}">
              <span class="block-heading"
                (click)="goToUrl(block);$event.preventDefault();$event.stopPropagation()">{{block.blockName}}</span>
            </a>
            <a *ngIf="clientAccess !== 'disabled' && !selectedClient" href="javascript:void(0)"
              title="{{block.isAccessRestricted ? 'Access Restricted' : block.description}}">
              <span class="block-heading"
                (click)="goToUrl(block);$event.preventDefault();$event.stopPropagation()">{{block.blockName}}</span>
            </a>
            <a *ngIf="clientAccess === 'disabled'" href="javascript:void(0)"
              title="{{block.isAccessRestricted ? 'Access Restricted' : block.description}}"
              [ngClass]="{'block-heading-ds': clientAccess === 'disabled'}">
              {{block.blockName}}
            </a>
          </span><br />
          <span class="block-description">{{block.description}}</span>
        </span>
      </a>
    </div>
  </ng-container>
</mat-card>

<mat-card appearance="outlined" class="dashboard-card single-card" *ngIf="isWaiverManagementModule || singleModuleTile">
  <ng-container>
    <div class="dasboard-card-block"
      *ngIf="canAccessWaiver ? module?.canAccess && !hideOnDashboard(module?.blockName) : true">
      <a fxLayoutGap="40px">
        <span fxFlex="10" class="block-image">
          <img src="{{module?.image}}" [ngClass]="{'img-disabled':!canAccessWaiver}"
            alt="{{module?.blockName}} image" />
        </span>
        <span fxFlex>
          <span class="block-heading">
            <strong>
              <a *ngIf="selectedClient" href="javascript:void(0)" routerLink="/{{module?.url}}"
                title="{{module?.description}}">
                <span class="block-heading"
                  (click)="$event.preventDefault();$event.stopPropagation();goToUrl(module);">{{module?.blockName}}</span>
              </a>
              <a *ngIf="!selectedClient" href="javascript:void(0)" title="{{module?.description}}">
                <span class="block-heading"
                  (click)="$event.preventDefault();$event.stopPropagation();goToUrl(module);">{{module?.blockName}}</span>
              </a>
            </strong>
          </span><br />
          <span class="block-description">{{module?.description}}</span>
        </span>
      </a>
    </div>
  </ng-container>
</mat-card>
